import React, { Fragment } from "react";
import { translate } from "../Services/translation";

const FacetedSearchCompact = ({
    facetFilters,
    visibleDropdownMenu,
    toggleVisibleDropdownMenu,
    onFacetChange,
    onSubmit,
}) => (
    <Fragment>
        {facetFilters && facetFilters.length > 0 &&(
            <h3 className="subnav__header">
                {translate("facet.header.filter")}
            </h3>
        )}
        <ul className="faceted-search faceted-search--compact row">
            {facetFilters &&
                facetFilters.map(
                    (group, groupIndex, array) =>
                        group.options &&
                        group.options.length > 0 && (
                            <li
                                className={'columns small-12 medium-6 large-3 faceted-search__group ' + group.id }
                                key={`${group.label}-${groupIndex}`}
                            >
                                <div
                                    className={`faceted-search__group-header`}
                                    role="faceted-search-item-group"
                                >
                                    {group.label}
                                </div>
                                <ul className="faceted-search__sublist">
                                    {group.options &&
                                        group.options.map(
                                            (item, itemIndex, array) => (
                                                <li
                                                    key={`${item.label}-${itemIndex}`}
                                                    className="faceted-search__item"
                                                    role="faceted-search-item"
                                                >
                                                    <FacetedFilterCheckbox
                                                        item={item}
                                                        group={group}
                                                        onFacetChange={
                                                            onFacetChange
                                                        }
                                                    />
                                                </li>
                                            )
                                        )}
                                </ul>
                            </li>
                        )
                )}
        </ul>
        <li className="faceted-search__item faceted-search__button">
            <button
                className="filter__button btn btn-green"
                onClick={(event) => {
                    toggleVisibleDropdownMenu(-1);
                    onSubmit(facetFilters);
                }}
            >
                {translate("general.select")}
            </button>
        </li>
    </Fragment>
);

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">{item.label}</span>
    </label>
);

export default FacetedSearchCompact;
